"use client";
/* eslint-disable react/no-unescaped-entities */
// Modules
import React from "react";
import { useRouter } from "next/navigation";
import { Container } from "react-bootstrap";

// Styles
import "./styles.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import styles from "./account-closure.module.scss";

const AccountClosure = () => {
  const router = useRouter();

  return (
    <div className={styles.container}>
      <Container
        fluid
        className={`grey_text extra_sides_padding ${styles.container_margin}`}
      >
        <h1 className="heading_text light_black_text">
          <span className="primary_orange_text"> Account Closure for</span>{" "}
          TriOmoney's users
        </h1>
        <p className="paragraph_text">
          Trio is committed to security, We care deeply about the safety and
          security of our customer’s data.
        </p>

        <h4 className={`subheading_text light_black_text ${styles.subheading}`}>
          How to close an account?
        </h4>
        <p className="paragraph_text grey_text">
          We are here to help you in closing your account and getting your
          balance refunded to you.
        </p>
        <ul>
          <li>
            Since you are a Small PPI holder, you will have to verify your
            identity to get the balance refunded.
          </li>
          <li>
            Reach out to us at{" "}
            <a
              href="mailto:support@triotech.co.in?subject=Request%20for%20TriOmoney%20Account%20Closure&body=Dear%20Trio%20Money%20Team%2C%0A%0AI%20am%20writing%20to%20formally%20request%20the%20closure%20of%20my%20account%20with%20Trio%20Money.%20Please%20find%20my%20details%20below%3A%0A%0AName%3A%20%5BYour%20Full%20Name%5D%0APhone%20Number%3A%20%5BYour%20Phone%20Number%5D%0A%0ARegards."
              target="_blank"
            >
              support@triotech.co.in
            </a>{" "}
            with your details.
          </li>
          <li>
            We will send you a form which you have to fill and send us a scanned
            copy of it with the required documents.
          </li>
          <li>
            Once received, we will verify the details and you will receive the
            refund in your declared account.
          </li>
        </ul>
        <a
          className={`${styles.button_container}`}
          href="mailto:support@triotech.co.in?subject=Request%20for%20TriOmoney%20Account%20Closure&body=Dear%20Trio%20Money%20Team%2C%0A%0AI%20am%20writing%20to%20formally%20request%20the%20closure%20of%20my%20account%20with%20Trio%20Money.%20Please%20find%20my%20details%20below%3A%0A%0AName%3A%20%5BYour%20Full%20Name%5D%0APhone%20Number%3A%20%5BYour%20Phone%20Number%5D%0A%0ARegards."
          target="_blank"
        >
          Close Account
        </a>
      </Container>
    </div>
  );
};

export default AccountClosure;
